import Form from '@arivaa-react/components/form';

export function EditHeaderLogo() {
  const handleSubmit = async (values) => {
    console.log(values);
  };
  return (
    <div className="card navigation">
      <div className="heading">
        <p className="label">Edit Logo</p>
      </div>
      <div className="edit-form">
        <Form
          renderForm={({ renderElement }) => {
            return (
              <div className="item">
                {renderElement({
                  type: 'file',
                  name: 'photoURL',
                  label: 'Select Logo',
                  required: false,
                  fileCode: 'profileImage',
                })}
              </div>
            );
          }}
          onSubmit={handleSubmit}
          submitButtonProps={{
            children: 'Save',
          }}
        />
      </div>
    </div>
  );
}
